import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CardProps } from "../../types/components";
import { Image } from "../../api-client";
import ButtonRound from "../Labels/ButtonRound";
import noImage from "../../assets/png/no-image.png";
import { describe } from "node:test";
import { useProductDetailModal } from "../../context/ProductDetailModalContext";

type CardVariant = "default" | "small";

function Card({
  id,
  name,
  imageUrl,
  price,
  rating,
  imageUrls,
  phrases,
  description,
  variant = "default", // 👈 por defecto grande
}: CardProps & { imageUrls: Image[]; variant?: CardVariant }) {
  const location = useLocation();
  const navigate = useNavigate();
  const productDetailModal = useProductDetailModal();
  const [currentImage, setCurrentImage] = useState(
    imageUrls.length > 0 ? imageUrls[0].image : imageUrl || noImage,
  );
  const [fade, setFade] = useState(false);

  const handleClick = (id: number) => {
    if (productDetailModal) {
      productDetailModal.openProductDetail(id);
      return;
    }

    navigate(`/product-detail/${id}`);
  };

  useEffect(() => {
    if (imageUrls.length > 0) {
      const initialDelay = Math.floor(Math.random() * 3000);
      const timeout = setTimeout(() => {
        const interval = setInterval(() => {
          setFade(true);
          setTimeout(() => {
            setCurrentImage((prevImage) => {
              const currentIndex = imageUrls.findIndex(
                (img) => img.image === prevImage,
              );
              const nextIndex = (currentIndex + 1) % imageUrls.length;
              return imageUrls[nextIndex].image;
            });
            setFade(false);
          }, 500);
        }, 10000);

        return () => clearInterval(interval);
      }, initialDelay);

      return () => clearTimeout(timeout);
    }
  }, [imageUrls]);

  /** ===============================
   * RENDER DE CARD PEQUEÑA
   * =============================== */
  if (variant === "small") {
    return (
      <div
        className="w-36 bg-white rounded-lg shadow-md border border-gray-100 cursor-pointer"
        onClick={() => handleClick(id)}
      >
        <img
          src={currentImage}
          alt={name}
          className="w-full h-36 object-contain rounded-t-lg transition-all duration-300"
        />
        <div className="px-2 py-2 text-center">
          <h2 className="text-sm font-semibold truncate">{name}</h2>
          <p className="text-red-600 text-xs font-medium mt-1">${price}</p>
        </div>
      </div>
    );
  }

  /** ===============================
   * RENDER DE CARD GRANDE (DEFAULT)
   * =============================== */
  return (
    <div
      className="w-full shadow-lg  cursor-pointer"
      onClick={() => handleClick(id)}
    >
      {location.pathname === "/category" ? (
        <div>
          <div className="flex justify-center">
            <img
              src={currentImage}
              alt={name}
              className="w-full object-cover rounded-lg transition-all duration-300"
            />
          </div>
          <div className="flex justify-center items-center">
            <div className="pt-2">
              <h2 className="text-base font-semibold text-center">{name}</h2>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col h-full rounded-lg">
          <div className="flex justify-center h-96 md:h-[14rem] lg:h-[26rem] rounded-t-lg">
            <img
              src={currentImage}
              alt={name}
              className="w-full h-full object-cover  transition-all duration-300 rounded-t-lg"
            />
          </div>

          <div className="flex flex-col justify-between flex-grow px-4 py-4 pt-3 shadow-xl bg-white rounded-b-lg ">
            <div>
              <h3 className="text-2xl lg:text-base font-semibold text-left my-4">
                {name}
              </h3>

              <h3 className="text-2xl lg:text-base font-semibold text-left my-4">
                <div
                  className="content-html font-custom font-regular text-xs mt-2 line-clamp-2 overflow-hidden"
                  dangerouslySetInnerHTML={{ __html: description ?? "<p></p>" }}
                />
              </h3>
            </div>
            <div className="flex justify-between h-10">
              <p className="text-4xl font-bold text-gray-800 mb-4">${price}</p>
              <ButtonRound
                text={"Add to Cart"}
                onClick={() => {}}
                isSelected={true}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Card;
